// import axios from 'axios';
import $x from '@/utils/$x';
import { message, Message } from 'antd';
/**
 * 导出文件post请求
 * @param url 请求地址
 * @param params 请求表单参数
 */
export async function exportDataByPost(url, params) {
  $x.post(url, params, { responseType: 'blob' }).then((res) => {
    try {
      const blob = res.data;
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      // substring(7) 截去前面的utf-8''
      reader.onload = function (e) {
        const a = document.createElement('a');
        const fileName = res.headers['content-disposition']
          ? res.headers['content-disposition']
              .split(';')[1]
              .split('=')[1]
              .substring(7)
          : new Date().getTime() + '.xlsx';
        a.download = decodeURIComponent(fileName); // 解码
        a.href = e.target.result;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
    } catch (error) {
      console.log(error);
    }
  });
}
